import { UPDATE_ALGOS_LIST_STATS } from '../../constants/ActionTypes';

const algosListStats = (
  state = { totalPnl: null, days: [], brokers: [] },
  action
) => {
  switch (action.type) {
    case UPDATE_ALGOS_LIST_STATS:
      return action.data;
    default:
      return state;
  }
};

export default algosListStats;
